<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.descricao"
                        label="Descrição"
                        v-model="model.descricao"
                        :disabled="model.casaPaciente"
                        type="text"
                        uppercase
                    >

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    inline
                                    v-model="model.casaPaciente"
                                >
                                    Casa do paciente
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :searchFields="localForm.autocompleteFields.logradouro"
                        :repository="repositories.logradouro"
                        v-model="model.logradouro"
                        :textField="l => `${l.tipo.descricao} ${l.nome} - ${l.bairro.nome} - ${l.municipio.nome}`"
                        :validations="validations.logradouro"
                        :disabled="model.casaPaciente"
                        label="Logradouro"
                        resultsLimit="999"
                        uppercase
                    >

                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="model.semNumero || model.casaPaciente"
                        :validations="validations.numero"
                        label="Número"
                        v-model="model.numero"
                        number
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    inline
                                    v-model="model.semNumero"
                                    :disabled="model.casaPaciente"
                                >
                                    Sem número
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        disabled
                        label="Bairro"
                        v-model="form.bairroNome"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        disabled
                        label="Município"
                        v-model="form.municipioNome"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="1">
                    <rkm-form-input
                        disabled
                        label="UF"
                        v-model="form.estadoUf"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.tiposLogradouro"
                        text-field="descricao"
                        value-field="id"
                        label="Tipo"
                        v-model="form.logradouroTipoId"
                        show-default-option
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-checkbox
                        v-model="model.bloqueado"
                        inline
                    >
                        Inativar
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalLogradouro
            ref="ModalLogradouro"
            @save="loadLogradouro"
        />
    </div>
</template>

<script>

// Components.
import ModalLogradouro from '@/components/cadastro/logradouro/Modal'

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        ModalLogradouro,
    },
    computed: {
        validations() {
            return {
                descricao: { required: true, max: 100 },
                logradouro: { required: true },
                numero: {
                    required: !this.model.semNumero,
                    max: 6
                },
            }
        },
    },
    created() {

        this.repositories.ponto = this.getConectaSusRepository('transportePaciente.ponto')
        this.repositories.logradouro = this.getConectaSusRepository('cadastro.localizacao.logradouro')

        this.load()
    },
    data: () => ({
        repositories: {
            ponto: null,
            logradouro: null,
        },
        form: null,
        localForm: {
            autocompleteFields: {
                logradouro: [
                    { key: 'tipo.descricao', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            },
        },
        model: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.ponto.edit(this.id) :
                this.repositories.ponto.create()

            request
                .then(({ data }) => this.setData(data.form || null, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        const modelSnakeCase = this.prepareData()

                        const request = modelSnakeCase.id === undefined || modelSnakeCase.id === null ?
                            this.repositories.ponto.store(modelSnakeCase) :
                            this.repositories.ponto.update(modelSnakeCase.id, modelSnakeCase)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            const ponto = this.clone(this.model)

            ponto.id = this.trataNull(ponto.id)

            if (!ponto.casaPaciente) {

                ponto.logradouro_id = ponto.logradouro.id
            } else {

                ponto.logradouro_id =  null
            }

            ponto.bloqueado = this.convertBooleanToBinary(ponto.bloqueado)

            delete(ponto.semNumero)
            delete(ponto.logradouro)

            return this.camelObjectKeysToSnakeRecursive(ponto)
        },
        loadLogradouro(logradouro) {

            this.$nextTick(() => this.model.logradouro = logradouro)
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        id: { type: [Number], default: null }
    },
    watch: {
        'model.casaPaciente': function (casaPaciente) {

            if (casaPaciente) {

                this.model.descricao = null
                this.model.logradouro = null
                this.model.numero = null
                this.model.semNumero = false
            }
        },
        'model.semNumero': function (semNumero) {

            if (semNumero) {

                this.model.numero = null
            }
        },
        'model.logradouro': function (logradouro) {

            if (logradouro) {

                this.form.bairroNome = logradouro.bairro.nome
                this.form.municipioNome = logradouro.municipio.nome
                this.form.estadoUf = logradouro.municipio.estado.uf
                this.form.logradouroTipoId = logradouro.tipo.id
            }
            else {

                this.form.bairroNome = ''
                this.form.municipioNome = ''
                this.form.estadoUf = ''
                this.form.logradouroTipoId = null
            }
        },
    },
}
</script>